import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import config from "../../../../config/config";
import { Spinner } from "react-bootstrap";

const initialValues = {
  email: "",
};

function ForgotPassword(props) {
  const { intl } = props;
  const [isRequested] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Formato errato")
      .min(3, "Minimo 3 caratteri")
      .max(50, "Massimo 50 caratteri")
      .required(
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
      ),
  });

  const [message, setMessage] = useState(false);
  const [color, setColor] = useState(false);
  const [loading, setLoading] = useState(false);

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values) => {
      setLoading(true);
      const options = {
        headers: {
          Authorization:
            "271c4d716fcf0e9555b51cffed666b4321f98f7f8bbeb9ae8bfc67752b4db8a2",
        },
        method: "POST",
        body: JSON.stringify({
          email: values.email,
        }),
      };
      fetch(config.apiUrl + "users/ForgottenPassword.php", options)
        .then((response) => response.json())
        .then((data) => {
          setMessage(data.message);
          setColor(data.color);
        })
        .then(() => setLoading(false));
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">Dimenticato la password ?</h3>
            <div className="text-muted font-weight-bold">
              Inserisci la tua email per reimpostare la password.
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                type="email"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "email"
                )}`}
                name="email"
                onChange={() => {
                  setColor(false);
                  setMessage(false);
                }}
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.email}</div>
                </div>
              ) : null}
            </div>
            {message !== false && color !== false ? (
              <span style={{ color: color }} className="col-12">
                {message}
              </span>
            ) : null}
            <div className="form-group d-flex flex-wrap flex-center">
              <Link to="/auth">
                <button
                  disabled={loading}
                  type="button"
                  id="kt_login_forgot_cancel"
                  className="btn btn-light-warning font-weight-bold px-9 py-4 my-3 mx-4 btn-sm"
                >
                  Login
                </button>
              </Link>
              <button
                disabled={loading}
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4 btn-sm"
                onClicK={formik.handleSubmit}
              >
                {loading ? (
                  <Spinner animation="border" variant="light" />
                ) : (
                  "Invia"
                )}
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
